import backendRequest from './index.js';

export const listStudents = (former) => backendRequest('GET', '/students/list?former=' + former);

export const listParents = () => backendRequest('GET', '/students/list-parents');

export const listUsers = () => backendRequest('GET', '/users-management/list-users');

export const listRoles = () => backendRequest('GET', '/permissions/list-roles');

export const listSubjects = () => backendRequest('GET', '/subjects/list-subjects');

export const addSubject = (data) => backendRequest('POST', `/subjects/add-subject`, data);

export const editSubject = (id, data) =>
    backendRequest('POST', `/subjects/edit-subject/${id}`, data);

export const deleteSubject = (id) => backendRequest('POST', `/subjects/delete-subject/${id}`);

export const listTrainers = () => backendRequest('GET', '/employees/list-trainers');

export const addHours = (data) => backendRequest('POST', '/student-hours/add', data);

export const editHours = (id, data) =>
    backendRequest('POST', '/student-hours/edit', { id, ...data });

export const deleteHours = (id, reason) =>
    backendRequest(reason ? 'POST' : 'GET', `/student-hours/delete/${id}`, { reason });

export const listPay = () => backendRequest('GET', '/employees/list-pay');

export const listAllPay = (month) =>
    backendRequest('POST', '/employees/list-all-pay', month ? { group_by: month } : undefined);

export const listDues = () => backendRequest('GET', '/students/list-dues');

export const listHours = () => backendRequest('GET', '/student-hours/list-hours');

export const markHourAsPaid = (id) => backendRequest('POST', `/student-hours/mark-hour-as-paid`, { id });

export const paySalary = (data) => backendRequest('POST', '/employees/pay-salary', data);

export const payDues = (data) => backendRequest('POST', '/students/pay-dues', data);

export const togglePreference = ({ id, type }) =>
    backendRequest('POST', '/student-preferences/toggle', { id, type });

export const sendWelcomeEmail = (id) => backendRequest('POST', '/students/send-welcome-email', { id });

export const sendGoodbyeEmail = (id) => backendRequest('POST', '/students/send-goodbye-email', { id });

export const updateStudent = (
    id,
    {
        student_firstname,
        student_lastname,
        student_phone,
        parent_firstname,
        parent_lastname,
        parent_phone,
        parent_email,
    }
) =>
    backendRequest('POST', `/students/update/${id}`, {
        student_firstname,
        student_lastname,
        student_phone,
        parent_firstname,
        parent_lastname,
        parent_phone,
        parent_email,
    });

export const getPayData = () => backendRequest('GET', '/employees/get-pay-data');

export const assignRole = (user, role, sendEmail) =>
    backendRequest('POST', '/permissions/assign-role', { user, role, sendEmail });

export const unassignRole = (user, role) =>
    backendRequest('POST', '/permissions/unassign-role', { user, role });

export const assignParent = (student, parent) =>
    backendRequest('POST', `/students/assign-parent/${student}`, { id: parent });

export const unassignParent = (id) => backendRequest('POST', `/students/unassign-parent/${id}`);

export const addNonUserParent = (id, { firstname, lastname, email, phone }) =>
    backendRequest('POST', `/students/add-parent/${id}`, {
        firstname,
        lastname,
        email,
        phone,
    });

export const listHoursSummary = () => backendRequest('GET', '/student-hours/list-summary');

export const editSummary = (id, data) =>
    backendRequest('POST', `/student-hours/edit-summary/${id}`, data);

export const addStudentPreference = ({ student, trainer, preference }) =>
    backendRequest('POST', '/student-preferences/add', { student, trainer, preference });

export const deleteStudentPreference = (student, trainer) =>
    backendRequest('POST', '/student-preferences/delete', { student, trainer })

export const addAddition = ({ trainer, amount, date, description }) =>
    backendRequest('POST', '/additions/add', { trainer, amount, date, description });

export const editAddition = (id, data) =>
    backendRequest('POST', `/additions/edit/${id}`, data);

export const deleteAddition = (id, data) =>
    backendRequest('POST', `/additions/delete/${id}`, data);

export const listAdditions = (group_by) =>
    backendRequest('GET', '/additions/list' + (group_by ? `?group_by=${group_by}` : ''));
